<template>
  <div class="" :class="{ reported: item != null && item.sgL_IsShow == null }">
    <div class="a">
      <ReportMaskVue
        v-if="item != null && item.sgL_IsShow == null"
        class="mask"
      ></ReportMaskVue>
      <videoVue
        @ck="detail"
        :id="id"
        :url="url"
        :poster="poster"
        :poster2="poster2"
        :IsShow="IsShow"
      ></videoVue>
      <cloubToolVue
        :likeNum="likeCount"
        @like="$emit('like')"
        @detail="detail"
        @viewData="$emit('viewData')"
        :showDetail="showDetail"
        :showViewData="showViewData"
      >
        <template v-slot:menu>
          <slot name="SpecifyMenu"></slot>
        </template>
      </cloubToolVue>
    </div>
    <cloubDetailVue
      :avatar="avatar"
      :title="title"
      :authorName="authorName"
      :displayName="displayName"
      :lookCount="lookCount"
      :date="date"
      :userId="item.sgL_UserID"
    ></cloubDetailVue>
  </div>
</template>

<script>
import cloubToolVue from "./cloubTool.vue";
import moreMenuVue from "./moreMenu.vue";
import videoVue from "./video.vue";
import ReportMaskVue from "./ReportMask.vue";
import cloubDetailVue from "./cloubDetail.vue";

export default {
  data() {
    return {
      isReport: false,
    };
  },
  components: {
    videoVue,
    moreMenuVue,
    cloubToolVue,
    ReportMaskVue,
    cloubDetailVue,
  },
  // inject: ["root_deleteFunc", "root_getSingleData", "root_copyLink"],
  props: {
    id: { Type: Number, required: true },
    url: { Type: String, required: true },
    avatar: { Type: String, required: true },
    authorName: { Type: String, required: true },
    displayName: { Type: String, required: true },
    date: { Type: String, required: true },
    lookCount: { Type: Number, default: 0, required: true },
    title: { Type: String, required: false },
    likeCount: { Type: Number, default: 0, required: true },
    poster: { Type: String, required: false },
    poster2: { Type: String, required: false },
    showDetail: { Type: Boolean, default: true },
    showViewData: { Type: Boolean, default: true },
    item: { Type: Object, default: null },
    IsShow: { Type: Object, default: 1 },
  },
  created() {
    if (this.item != null && this.item.sgL_IsShow == null) {
      this.isReport = true;
    }
  },
  methods: {
    detail() {
      console.log(999999999999);
      this.$router.push({
        name: "DisplayVideo",
        query: { id: this.id },
      });
    },
    viewData() {
      this.root_getSingleData(this.id, null, true);
    },
  },
};
</script>

<style scoped>
.user-logo2 {
  width: 40px;
  height: 40px;
  display: inline-block;
  border-radius: 20px;
  background-size: cover;
}
.cloud-vtitle {
  font-size: 0.9em;
}

.pool-fm .cloud-info {
  display: flex;
  flex-direction: row;
}
.detail {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.vtitle {
  padding: 0px 5px 0px 5px;
  line-height: 20px;
  display: inline-block;
  color: #000;
  overflow-wrap: anywhere;
  font-size: 0.9em;
}
.vname {
  padding: 5px 5px 0px 5px;
  line-height: 10px;
  display: inline-block;
  color: #8c8c8c;
  font-size: 10px;
}
.vcounter {
  padding: 8px 5px 0px 5px;
  line-height: 10px;
  display: inline-block;
  color: #8c8c8c;
  font-size: 10px;
}
.rt {
  float: right;
}
.a {
  position: relative;
  /* z-index: 1; */
}
.mask {
  z-index: 1;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
}

.a >>> .reportMask {
}
</style>


// WEBPACK FOOTER //
// src/components/Social/singleVideo.vue